// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LjSTw","type":"styles_type__2vZ49","choices":"styles_choices__1fCgz"};